// src/pages/HRAdmin/Department/EditDepartmentPage.js
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../../services/api';

import {
  Box,
  Button,
  TextField,
  Typography,
  Paper,
  MenuItem
} from '@mui/material';

function EditDepartmentPage() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [managers, setManagers] = useState([]);
  const [formData, setFormData] = useState({
    name: '',
    code: '',
    description: '',
    manager_id: '',
    cost_center: '',
  });

  useEffect(() => {
    // 1) Load department info
    api.get(`/admin/departments/${id}`)
      .then((res) => {
        const dept = res.data;
        setFormData({
          name: dept.name || '',
          code: dept.code || '',
          description: dept.description || '',
          manager_id: dept.manager_id ? String(dept.manager_id) : '',
          cost_center: dept.cost_center || '',
        });
      })
      .catch((err) => console.error('Failed to load department:', err));

    // 2) Load managers
    api.get('/admin/users?role=manager')
      .then((res) => setManagers(res.data))
      .catch((err) => console.error('Failed to fetch managers:', err));
  }, [id]);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    api
      .put(`/admin/departments/${id}`, formData)
      .then(() => navigate('/admin/departments'))
      .catch((err) => console.error('Error updating department:', err));
  };

  return (
    <Paper sx={{ p: 3, maxWidth: 600, mx: 'auto', mt: 4 }}>
      <Typography variant="h5" gutterBottom>
        Edit Department
      </Typography>

      <Box component="form" onSubmit={handleSubmit}>
        <TextField
          label="Department Name"
          name="name"
          value={formData.name}
          onChange={handleChange}
          required
          fullWidth
          margin="normal"
        />
        <TextField
          label="Code"
          name="code"
          value={formData.code}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />
        <TextField
          label="Description"
          name="description"
          value={formData.description}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />
        <TextField
          label="Manager"
          name="manager_id"
          select
          value={formData.manager_id}
          onChange={handleChange}
          fullWidth
          margin="normal"
        >
          <MenuItem value="">No Manager</MenuItem>
          {managers.map((mgr) => (
            <MenuItem key={mgr.employee_code} value={mgr.employee_code}>
              {mgr.name}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          label="Cost Center"
          name="cost_center"
          value={formData.cost_center}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />

        <Box mt={2} display="flex" justifyContent="flex-end">
          <Button
            variant="outlined"
            color="inherit"
            onClick={() => navigate('/admin/departments')}
            sx={{ mr: 2 }}
          >
            Cancel
          </Button>
          <Button type="submit" variant="contained">
            Save Changes
          </Button>
        </Box>
      </Box>
    </Paper>
  );
}

export default EditDepartmentPage;
